import { render } from "./rerservationDetails.vue?vue&type=template&id=31b439c5"
import script from "./rerservationDetails.vue?vue&type=script&lang=js"
export * from "./rerservationDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__